var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-between flex-wrap"},[_c('vacancy-overview-card',{attrs:{"vacancy":_vm.vacancy,"currentOffice":_vm.currentOffice}}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-8 p-0 pl-sm-3"},[_c('vacancy-details-card',{attrs:{"vacancy":_vm.vacancy,"currentOffice":_vm.currentOffice}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6152aae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vacancies/vacancy-info.vue
// module id = null
// module chunks = 